import "./Advisory.css";
import Hero from "../../components/Hero/Hero";
import Heading from "../../components/Heading/Heading";
import SubHeading from "../../components/SubHeading/SubHeading";
import ImagesList from "../../components/ImagesList/ImagesList";
import H1 from "../../components/H1/H1";
import usePageTitle from "../../hooks/usePageTitle";

const Advisory = () => {
    usePageTitle("Advisory");

    const images = [
        {
            title: "Investment advisory",
            image: "/images/waves/advisory1.jpg",
            content:
                "Grounded in a holistic canvas of holdings, we partner with families to sculpt investment strategies that harmonise risk, liquidity, and goals.",
        },
        {
            title: "Deal advisory",
            image: "/images/waves/advisory2.jpg",
            content:
                "We guide families through personal transactions, curating opportunities, choreographing diligence, and shaping negotiations.",
        },
        {
            title: "Philanthropy advisory",
            image: "/images/waves/advisory3.jpg",
            content:
                "We help families shape giving goals and guardrails, craft structures, surface opportunities, measure impact, and tell the story of results.",
        },
    ];

    return (
        <div className="page-content advisory-page">
            <Hero name="about-river">
                <H1>Advisory</H1>
            </Hero>

            <section className="padded">
                <div className="container">
                    <Heading>
                        We care for owner capital with a clear brief: shape policy, guide
                        investments, steward operations, compound steadily, and illuminate
                        performance in plain language.
                    </Heading>

                    <SubHeading>
                        "We believe capital is a means, not an end. We believe capital can serve a
                        greater outcome, not be the outcome. Our approach honours the human stories
                        and dreams behind wealth."
                    </SubHeading>

                    <div className="spacer"></div>

                    <ImagesList data={images} />
                </div>
            </section>
        </div>
    );
};

export default Advisory;
